(function (root, factory) {
  "use strict";
  var api = factory();
  if (typeof module === "object" && module.exports) module.exports = api;
  if (root) root.IDPProjectHubCore = api;
})(typeof window !== "undefined" ? window : globalThis, function () {
  "use strict";

  var SCORE_WEIGHTS = Object.freeze({
    sector: 50,
    primaryNeed: 60,
    derivedNeed: 18,
    contextualTerm: 2,
    contextualTermLimit: 9,
    documentationMaximum: 10
  });

  var MIN_COMPATIBILITY_SCORE = SCORE_WEIGHTS.sector + SCORE_WEIGHTS.primaryNeed;
  var STORAGE_TTL_MS = 30 * 24 * 60 * 60 * 1000;
  var API_ENDPOINT_PATH = "/api/project-hub/projects";
  var API_PROTOCOL_VERSION = "1";
  var CONSENT_COPY_VERSION = "2026-08-30.v2";
  var APPROVED_REMOTE_API_ENDPOINTS = Object.freeze(["https://idp-proyecto-vivo.idpi-voice-cloudflare.workers.dev/api/project-hub/projects"]);
  var TECHNICAL_STORAGE_FIELDS = Object.freeze([
    "sector", "need", "support", "condition", "exposure",
    "traffic", "finish", "area", "urgency", "description"
  ]);

  var NEED_RULES = Object.freeze({
    condition: {
      humedad: ["humedad-soporte"],
      fisuras: ["flexibilidad"]
    },
    exposure: {
      "exterior-uv": ["uv-exterior"],
      "humedo-limpieza": ["antideslizante-higienico"],
      quimica: ["quimica-inmersion"],
      inmersion: ["quimica-inmersion", "impermeabilizacion"]
    },
    traffic: {
      "ligero-medio": ["trafico-ligero"],
      pesado: ["trafico-pesado"],
      vehicular: ["trafico-vehicular"],
      conductivo: ["conductividad"]
    },
    finish: {
      antideslizante: ["antideslizante-higienico"],
      decorativo: ["decorativo"],
      flexible: ["flexibilidad"],
      impermeable: ["impermeabilizacion"]
    },
    urgency: {
      corta: ["puesta-servicio-rapida"],
      urgente: ["puesta-servicio-rapida"]
    }
  });

  var CONTEXT_LABELS = Object.freeze({
    support: {
      hormigon: "hormigón",
      "mortero-cementoso": "mortero cementoso",
      metal: "metal acero aluminio",
      asfalto: "asfalto bituminoso",
      ceramica: "cerámica baldosa gres",
      madera: "madera",
      "revestimiento-existente": "revestimiento existente",
      mixto: "soporte mixto"
    },
    condition: {
      "nuevo-cohesivo": "soporte nuevo cohesivo",
      humedad: "humedad agua vapor",
      fisuras: "fisuras grietas juntas movimiento",
      contaminado: "aceite grasa contaminación",
      debil: "débil pulverulento disgregado",
      irregular: "irregular baches desnivel regularización",
      revestido: "revestimiento anterior"
    },
    exposure: {
      "interior-seco": "interior seco",
      "exterior-uv": "exterior radiación ultravioleta",
      "humedo-limpieza": "húmedo limpieza higiene",
      quimica: "agentes químicos",
      inmersion: "inmersión contención agua",
      termica: "temperatura choque térmico"
    },
    traffic: {
      peatonal: "peatonal",
      "ligero-medio": "tráfico ligero medio",
      pesado: "tráfico pesado carretillas cargas abrasión",
      vehicular: "vehículos parking aparcamiento",
      conductivo: "conductividad ESD",
      "sin-trafico": "sin tráfico"
    },
    finish: {
      liso: "liso continuo",
      antideslizante: "antideslizante texturado",
      decorativo: "decorativo acabado visible",
      flexible: "flexible elástico",
      impermeable: "impermeabilización membrana continua",
      transparente: "transparente incoloro"
    },
    urgency: {
      planificada: "intervención planificada",
      corta: "puesta en servicio rápida parada corta",
      urgente: "puesta en servicio rápida urgente"
    }
  });

  var STOP_WORDS = Object.freeze([
    "para", "como", "sobre", "entre", "desde", "hasta", "este", "esta", "estos", "estas",
    "tiene", "tengo", "zona", "suelo", "sistema", "producto", "necesito", "proyecto", "obra",
    "unas", "unos", "pero", "porque", "donde", "cuando", "todo", "toda", "muy", "mas"
  ]);

  function normalize(value) {
    return String(value == null ? "" : value)
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function safeCatalogUrl(value, baseUrl) {
    var raw = String(value == null ? "" : value).trim();
    if (!raw) return "";
    for (var index = 0; index < raw.length; index += 1) {
      var code = raw.charCodeAt(index);
      if (code <= 31 || code === 92 || code === 127) return "";
    }
    try {
      var base = new URL(baseUrl || "https://idpproductos.com/");
      var baseHostname = base.hostname.toLowerCase();
      var localBase = baseHostname === "localhost" || baseHostname === "127.0.0.1";
      var secureBase = base.protocol === "https:" || (localBase && base.protocol === "http:");
      if (!secureBase || base.username || base.password) return "";

      var url = new URL(raw, base);
      if (url.username || url.password) return "";
      var isAbsolute = /^[a-z][a-z0-9+.-]*:/i.test(raw) || raw.indexOf("//") === 0;
      if (!isAbsolute) {
        return url.origin === base.origin && (url.protocol === "https:" || localBase) ? url.href : "";
      }

      var hostname = url.hostname.toLowerCase();
      if (hostname === "idpproductos.com" || hostname === "www.idpproductos.com") {
        return url.protocol === "https:" && !url.port ? url.href : "";
      }

      var qaHost = hostname === "localhost" || hostname === "127.0.0.1";
      var localProtocol = url.protocol === "http:" || url.protocol === "https:";
      return qaHost && localBase && localProtocol ? url.href : "";
    } catch (error) {
      return "";
    }
  }

  function safeApiEndpoint(value, baseUrl, enabled, approvedRemoteEndpoints) {
    if (enabled !== true) return "";
    var raw = String(value == null ? "" : value).trim();
    if (!raw) return "";
    for (var index = 0; index < raw.length; index += 1) {
      var code = raw.charCodeAt(index);
      if (code <= 31 || code === 92 || code === 127) return "";
    }
    try {
      var base = new URL(baseUrl || "");
      var baseHostname = base.hostname.toLowerCase();
      var localBase = baseHostname === "localhost" || baseHostname === "127.0.0.1";
      var idpBase = baseHostname === "idpproductos.com" || baseHostname === "www.idpproductos.com";
      var secureBase = base.protocol === "https:" || (localBase && base.protocol === "http:");
      if ((!idpBase && !localBase) || !secureBase || base.username || base.password) return "";
      if (idpBase && base.port) return "";

      var endpoint = new URL(raw, base);
      if (endpoint.username || endpoint.password || endpoint.search || endpoint.hash) return "";
      if (endpoint.pathname !== API_ENDPOINT_PATH) return "";
      if (endpoint.origin === base.origin) {
        if (endpoint.protocol !== "https:" && !(localBase && endpoint.protocol === "http:")) return "";
        return endpoint.href;
      }

      var remoteHostname = endpoint.hostname.toLowerCase();
      var workerHost = remoteHostname.indexOf("idp-proyecto-vivo.") === 0 && remoteHostname.endsWith(".workers.dev");
      if (!idpBase || endpoint.protocol !== "https:" || endpoint.port || !workerHost) return "";
      var approved = Array.isArray(approvedRemoteEndpoints) ? approvedRemoteEndpoints : [];
      var exactMatch = approved.some(function (item) {
        try {
          return new URL(String(item)).href === endpoint.href;
        } catch (error) {
          return false;
        }
      });
      return exactMatch ? endpoint.href : "";
    } catch (error) {
      return "";
    }
  }

  function isValidInternationalPhone(value) {
    var raw = String(value == null ? "" : value).trim();
    if (!raw) return true;
    if (!/^[+\d\s().-]+$/.test(raw)) return false;
    var digits;
    if (raw.indexOf("+") === 0) digits = raw.replace(/\D/g, "");
    else if (raw.indexOf("00") === 0) digits = raw.slice(2).replace(/\D/g, "");
    else return false;
    return /^[1-9]\d{7,14}$/.test(digits);
  }

  function submissionIdentity(payload) {
    try {
      var copy = JSON.parse(JSON.stringify(payload || {}));
      delete copy.updatedAt;
      return JSON.stringify(copy);
    } catch (error) {
      return "";
    }
  }
  function toNumber(value, fallback) {
    var parsed = Number.parseFloat(String(value == null ? "" : value).replace(",", "."));
    return Number.isFinite(parsed) ? parsed : (fallback || 0);
  }

  function round(value, decimals) {
    var places = decimals == null ? 2 : decimals;
    var factor = Math.pow(10, places);
    return Math.round((value + Number.EPSILON) * factor) / factor;
  }

  function unique(values) {
    return Array.from(new Set((values || []).filter(Boolean)));
  }

  function labelMap(items) {
    return (items || []).reduce(function (map, item) {
      map[item.id] = item.label;
      return map;
    }, {});
  }

  function derivedNeeds(input) {
    var needs = [];
    Object.keys(NEED_RULES).forEach(function (field) {
      var value = input && input[field];
      var matches = value && NEED_RULES[field][value];
      if (matches) needs = needs.concat(matches);
    });
    return unique(needs.filter(function (id) { return id !== (input && input.need); }));
  }

  function contextualTerms(input) {
    var pieces = [];
    Object.keys(CONTEXT_LABELS).forEach(function (field) {
      var value = input && input[field];
      if (value && CONTEXT_LABELS[field][value]) pieces.push(CONTEXT_LABELS[field][value]);
    });
    if (input && input.description) pieces.push(input.description);
    return unique(normalize(pieces.join(" ")).split(" ").filter(function (term) {
      return term.length >= 4 && STOP_WORDS.indexOf(term) === -1;
    }));
  }

  function isLayerCalculable(layer) {
    return Boolean(layer && toNumber(layer.consumption, 0) > 0);
  }

  function isLayerDocumented(layer) {
    if (!isLayerCalculable(layer)) return false;
    return normalize(layer.documentStatus) === "validada" ||
      toNumber(layer.officialConsumption, 0) > 0 ||
      Boolean(layer.officialLabel) ||
      layer.projectConsumption === true;
  }

  function documentationCoverage(system) {
    var layers = system && Array.isArray(system.layers) ? system.layers : [];
    var calculable = layers.filter(isLayerCalculable);
    var documented = calculable.filter(isLayerDocumented);
    var verified = calculable.filter(function (layer) {
      return normalize(layer.documentStatus) === "validada";
    });
    var projectSpecific = calculable.filter(function (layer) { return layer.projectConsumption === true; });
    return {
      totalLayers: layers.length,
      calculableLayers: calculable.length,
      documentedLayers: documented.length,
      verifiedLayers: verified.length,
      projectSpecificLayers: projectSpecific.length,
      missingConsumptionLayers: layers.length - calculable.length,
      reviewRequiredLayers: calculable.length - verified.length,
      percent: calculable.length ? Math.round((documented.length / calculable.length) * 100) : 0
    };
  }

  function systemSearchText(system) {
    return normalize([
      system && system.name,
      system && system.technicalName,
      system && system.description,
      system && system.applications,
      system && system.keywords
    ].join(" "));
  }

  function scoreSystem(system, marketEntry, input, needLabels, sectorLabels) {
    var score = 0;
    var reasons = [];
    var mappedSectors = marketEntry && Array.isArray(marketEntry.sectors) ? marketEntry.sectors : [];
    var mappedNeeds = marketEntry && Array.isArray(marketEntry.needs) ? marketEntry.needs : [];
    var additionalNeeds = derivedNeeds(input || {});
    var terms = contextualTerms(input || {});
    var searchable = systemSearchText(system || {});
    var matchedTerms = terms.filter(function (term) {
      return searchable.indexOf(term) !== -1;
    }).slice(0, SCORE_WEIGHTS.contextualTermLimit);
    var matchedDerived = additionalNeeds.filter(function (id) { return mappedNeeds.indexOf(id) !== -1; });
    var coverage = documentationCoverage(system || {});

    if (input && input.sector && mappedSectors.indexOf(input.sector) !== -1) {
      score += SCORE_WEIGHTS.sector;
      reasons.push("Sector relacionado en el mapa técnico: " + (sectorLabels[input.sector] || input.sector) + ".");
    }
    if (input && input.need && mappedNeeds.indexOf(input.need) !== -1) {
      score += SCORE_WEIGHTS.primaryNeed;
      reasons.push("Necesidad principal relacionada: " + (needLabels[input.need] || input.need) + ".");
    }
    matchedDerived.forEach(function (id) {
      score += SCORE_WEIGHTS.derivedNeed;
      reasons.push("Criterio adicional relacionado: " + (needLabels[id] || id) + ".");
    });
    if (matchedTerms.length) {
      score += matchedTerms.length * SCORE_WEIGHTS.contextualTerm;
      reasons.push("Coincidencia contextual con " + matchedTerms.length + " dato" + (matchedTerms.length === 1 ? "" : "s") + " del expediente.");
    }

    var documentationPoints = Math.min(
      SCORE_WEIGHTS.documentationMaximum,
      Math.round(coverage.percent / 10)
    );
    score += documentationPoints;
    reasons.push(
      "Cobertura de cálculo registrada: " + coverage.documentedLayers + " de " + coverage.calculableLayers + " capas calculables."
    );

    if (!reasons.length) reasons.push("Sin relación directa suficiente; requiere búsqueda técnica manual.");

    return {
      id: system.id,
      score: score,
      reasons: reasons,
      matchedDerivedNeeds: matchedDerived,
      matchedContextTerms: matchedTerms,
      sectors: mappedSectors.slice(),
      needs: mappedNeeds.slice(),
      directSectorMatch: Boolean(input && input.sector && mappedSectors.indexOf(input.sector) !== -1),
      directNeedMatch: Boolean(input && input.need && mappedNeeds.indexOf(input.need) !== -1),
      coverage: coverage,
      system: system
    };
  }

  function rankSystems(recipes, marketMap, input) {
    var systems = Array.isArray(recipes) ? recipes : ((recipes && recipes.systems) || []);
    var marketSystems = (marketMap && marketMap.systems) || {};
    var needLabels = labelMap((marketMap && marketMap.needs) || []);
    var sectorLabels = labelMap((marketMap && marketMap.sectors) || []);

    return systems.map(function (system) {
      return scoreSystem(system, marketSystems[system.id] || {}, input || {}, needLabels, sectorLabels);
    }).sort(function (a, b) {
      if (b.score !== a.score) return b.score - a.score;
      if (b.coverage.percent !== a.coverage.percent) return b.coverage.percent - a.coverage.percent;
      return String(a.system.technicalName || a.system.name || a.id)
        .localeCompare(String(b.system.technicalName || b.system.name || b.id), "es", { sensitivity: "base" });
    });
  }

  function criticalDataGaps(input) {
    var value = input || {};
    var gaps = [];
    if (!value.sector) gaps.push("Definir el sector de uso.");
    if (!value.need) gaps.push("Definir la necesidad principal.");
    if (!value.support) {
      gaps.push("Identificar el soporte.");
    } else if (value.support === "desconocido" || value.support === "mixto") {
      gaps.push("Identificar cada soporte y sus transiciones antes de comparar sistemas.");
    }
    if (!value.condition || value.condition === "desconocido") gaps.push("Comprobar el estado real del soporte.");
    if (!value.exposure || value.exposure === "desconocida") gaps.push("Definir la exposición dominante.");
    if (!value.traffic || value.traffic === "desconocido") gaps.push("Definir el tráfico o la solicitación prevista.");
    if (!value.finish || value.finish === "por-definir") gaps.push("Definir el acabado funcional requerido.");
    if (!(toNumber(value.areaM2, 0) > 0)) gaps.push("Confirmar una superficie positiva.");
    if (!value.description || String(value.description).trim().length < 20) {
      gaps.push("Describir las condiciones principales del caso.");
    }
    if (value.exposure === "quimica" || value.exposure === "inmersion") {
      gaps.push("Identificar agente, concentración, temperatura y tiempo de contacto para verificar compatibilidad.");
    }
    return unique(gaps);
  }

  function isSystemVerifiable(item) {
    if (!item || !item.coverage) return false;
    return item.directSectorMatch === true &&
      item.directNeedMatch === true &&
      item.score >= MIN_COMPATIBILITY_SCORE &&
      item.coverage.calculableLayers > 0 &&
      item.coverage.missingConsumptionLayers === 0 &&
      item.coverage.documentedLayers === item.coverage.calculableLayers;
  }

  function assessCompatibility(ranking, input) {
    var evaluated = Array.isArray(ranking) ? ranking : [];
    var criticalGaps = criticalDataGaps(input || {});
    var candidates = evaluated.filter(isSystemVerifiable);
    var compatible = criticalGaps.length === 0 && candidates.length > 0;
    return {
      threshold: MIN_COMPATIBILITY_SCORE,
      compatible: compatible,
      status: compatible ? "preseleccion_verificable" : "sin_sistema_compatible_verificable",
      message: compatible
        ? "La coincidencia mínima y la cobertura de cálculo se cumplen para una preselección sujeta a revisión técnica."
        : "Sin sistema compatible verificable: no se realiza el cálculo hasta completar datos críticos o disponer de una coincidencia documental suficiente.",
      criticalGaps: criticalGaps,
      evaluatedCount: evaluated.length,
      candidateCount: candidates.length,
      compatibleSystems: compatible ? candidates : []
    };
  }
  function calculateSystem(system, areaM2, calculatorCore) {

    var layers = system && Array.isArray(system.layers) ? system.layers.filter(isLayerCalculable) : [];
    var area = Math.max(0, toNumber(areaM2, 0));
    var calculated;

    if (calculatorCore && typeof calculatorCore.calculate === "function") {
      calculated = calculatorCore.calculate(area, 0, layers);
    } else {
      var fallbackRows = layers.map(function (layer) {
        var coats = Math.max(1, Math.round(toNumber(layer.coats, 1)));
        var required = area * toNumber(layer.consumption, 0) * coats;
        return {
          name: layer.name || "Producto IDP",
          phase: layer.phase || "Capa",
          consumption: toNumber(layer.consumption, 0),
          coats: coats,
          netKg: round(required, 2),
          requiredKg: round(required, 2),
          packages: { units: [], suppliedKg: 0, excessKg: 0 }
        };
      });
      calculated = {
        areaM2: round(area, 2),
        wastePercent: 0,
        rows: fallbackRows,
        totalRequiredKg: round(fallbackRows.reduce(function (sum, row) { return sum + row.requiredKg; }, 0), 2)
      };
    }

    calculated.rows = calculated.rows.map(function (row, index) {
      var source = layers[index] || {};
      return Object.assign({}, row, {
        officialLabel: source.officialLabel || "",
        documentStatus: source.documentStatus || "",
        projectConsumption: source.projectConsumption === true,
        technicalName: source.technicalName || source.name || row.name,
        sheet: source.sheet || ""
      });
    });
    calculated.coverage = documentationCoverage(system || {});
    return calculated;
  }

  function buildPendingData(input, system) {
    var pending = [
      "Confirmar la ficha técnica vigente y la configuración exacta del sistema preseleccionado.",
      "Definir la preparación mecánica a partir de la cohesión, porosidad y contaminación reales del soporte.",
      "Revisar juntas, fisuras, encuentros, perímetros, sumideros y cambios de material.",
      "Registrar temperatura, humedad ambiental, temperatura del soporte y punto de rocío durante la aplicación.",
      "Definir merma de obra, sectorización, logística y formatos de suministro antes de pedir material."
    ];
    var value = input || {};

    if (!value.support || value.support === "desconocido" || value.support === "mixto") {
      pending.push("Identificar y documentar cada soporte presente y sus transiciones.");
    }
    if (value.condition === "humedad") {
      pending.push("Medir la humedad, determinar su origen y comprobar si existe presión de vapor o aporte continuo de agua.");
    }
    if (value.condition === "fisuras") {
      pending.push("Clasificar fisuras y juntas como estables o activas y registrar anchura, profundidad, patrón y evolución.");
    }
    if (value.condition === "contaminado") {
      pending.push("Identificar el contaminante, su profundidad y el procedimiento de retirada compatible.");
    }
    if (value.condition === "debil") {
      pending.push("Comprobar resistencia y cohesión del soporte antes de definir una reconstrucción.");
    }
    if (value.condition === "irregular") {
      pending.push("Levantar la planimetría y cuantificar baches, pendientes y espesores de regularización.");
    }
    if (value.condition === "revestido") {
      pending.push("Identificar el revestimiento existente y comprobar adherencia y compatibilidad antes de recubrir.");
    }
    if (value.exposure === "quimica" || value.exposure === "inmersion") {
      pending.push("Identificar agente, concentración, temperatura, frecuencia y tiempo de contacto; solicitar resistencia documentada.");
    }
    if (value.exposure === "exterior-uv") {
      pending.push("Confirmar exposición solar, agua, pendientes, drenajes y estabilidad UV del acabado completo.");
    }
    if (value.exposure === "humedo-limpieza") {
      pending.push("Definir protocolo de limpieza, contaminantes, drenaje y requisito de textura verificable.");
    }
    if (value.exposure === "termica") {
      pending.push("Registrar temperaturas mínima y máxima, velocidad y frecuencia del cambio térmico.");
    }
    if (value.traffic === "pesado" || value.traffic === "vehicular") {
      pending.push("Cuantificar frecuencia de tráfico, carga por rueda, giros, impactos y recorridos dominantes.");
    }
    if (value.traffic === "conductivo") {
      pending.push("Definir el requisito eléctrico, método de ensayo y continuidad de la puesta a tierra.");
    }
    if (!value.finish || value.finish === "por-definir") {
      pending.push("Aprobar color, textura, brillo y facilidad de limpieza mediante una muestra física.");
    }
    if (!value.description || String(value.description).trim().length < 80) {
      pending.push("Añadir fotografías generales y de detalle, planos, historial de uso y reparaciones anteriores.");
    }

    var coverage = documentationCoverage(system || {});
    if (coverage.reviewRequiredLayers > 0) {
      pending.push(
        "Revisar documentalmente " + coverage.reviewRequiredLayers + " capa" +
        (coverage.reviewRequiredLayers === 1 ? "" : "s") + " que no figura" +
        (coverage.reviewRequiredLayers === 1 ? "" : "n") + " como ficha validada en el conjunto de datos."
      );
    }
    if (coverage.missingConsumptionLayers > 0) {
      pending.push(
        "Completar el consumo de " + coverage.missingConsumptionLayers + " capa" +
        (coverage.missingConsumptionLayers === 1 ? "" : "s") + " antes de cerrar cantidades."
      );
    }
    return unique(pending);
  }

  function nonDefinitiveDecision(assessment) {
    if (assessment && assessment.compatible === false) {
      return Object.freeze({
        type: "preseleccion_bloqueada",
        definitive: false,
        conclusionBlocked: true,
        status: "sin_sistema_compatible_verificable",
        message: "Sin sistema compatible verificable. El cálculo queda bloqueado hasta completar la información o revisar el caso técnicamente."
      });
    }
    return Object.freeze({
      type: "preseleccion",
      definitive: false,
      conclusionBlocked: true,
      status: "pendiente_revision_tecnica",
      message: "La herramienta ordena coincidencias documentadas y no confirma la idoneidad definitiva del sistema."
    });
  }
  function minimizeContact(contact) {
    var value = contact || {};
    return {
      companyProject: String(value.companyProject || "").trim(),
      name: String(value.name || "").trim(),
      email: String(value.email || "").trim(),
      phone: String(value.phone || "").trim(),
      locality: String(value.locality || "").trim(),
      preferredChannel: ["email", "phone"].indexOf(value.preferredChannel) !== -1 ? value.preferredChannel : ""
    };
  }

  function hasContactRoute(contact) {
    var value = minimizeContact(contact);
    return Boolean(value.email || value.phone);
  }

  function sanitizeStoredProject(payload) {
    var value = payload || {};
    var sourceForm = value.form && typeof value.form === "object" ? value.form : {};
    var technicalForm = {};
    TECHNICAL_STORAGE_FIELDS.forEach(function (field) {
      if (Object.prototype.hasOwnProperty.call(sourceForm, field)) {
        technicalForm[field] = String(sourceForm[field] == null ? "" : sourceForm[field]);
      }
    });
    return {
      version: 2,
      savedAt: String(value.savedAt || ""),
      projectId: String(value.projectId || ""),
      createdAt: String(value.createdAt || ""),
      selectedId: String(value.selectedId || ""),
      form: technicalForm
    };
  }

  function buildStoredProject(payload, nowMs) {
    var instant = Number.isFinite(nowMs) ? nowMs : Date.now();
    return sanitizeStoredProject(Object.assign({}, payload || {}, {
      version: 2,
      savedAt: new Date(instant).toISOString()
    }));
  }

  function isStoredProjectFresh(payload, nowMs) {
    var savedAt = Date.parse(payload && payload.savedAt);
    var now = Number.isFinite(nowMs) ? nowMs : Date.now();
    if (!Number.isFinite(savedAt) || savedAt > now + 5 * 60 * 1000) return false;
    return now - savedAt <= STORAGE_TTL_MS;
  }
  function buildDossier(input, ranking, selectedId, calculation, pending, metadata) {
    var evaluated = Array.isArray(ranking) ? ranking : [];
    var assessment = metadata && metadata.assessment ? metadata.assessment : null;
    var eligible = evaluated.filter(isSystemVerifiable);
    var dossierCompatible = Boolean(assessment && assessment.compatible === true && eligible.length > 0);
    var effectiveAssessment = dossierCompatible ? assessment : {
      threshold: assessment && assessment.threshold != null ? assessment.threshold : MIN_COMPATIBILITY_SCORE,
      compatible: false,
      status: "sin_sistema_compatible_verificable",
      criticalGaps: assessment && Array.isArray(assessment.criticalGaps)
        ? assessment.criticalGaps.slice()
        : ["La compatibilidad todavía no se ha evaluado con datos suficientes."],
      evaluatedCount: assessment && assessment.evaluatedCount != null ? assessment.evaluatedCount : evaluated.length,
      candidateCount: 0
    };
    var top = dossierCompatible ? eligible.slice(0, 3) : [];
    var selected = top.find(function (item) { return item.id === selectedId; }) || top[0] || null;
    return {
      schemaVersion: "idp-project-hub/1.0",
      projectId: metadata && metadata.projectId ? metadata.projectId : "",
      createdAt: metadata && metadata.createdAt ? metadata.createdAt : new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      requester: minimizeContact(metadata && metadata.contact),
      input: Object.assign({}, input || {}),
      compatibility: {
        threshold: effectiveAssessment.threshold,
        compatible: effectiveAssessment.compatible,
        status: effectiveAssessment.status,
        criticalGaps: (effectiveAssessment.criticalGaps || []).slice(),
        evaluatedCount: effectiveAssessment.evaluatedCount,
        candidateCount: effectiveAssessment.candidateCount
      },
      ranking: top.map(function (item, index) {
        return {
          rank: index + 1,
          systemId: item.id,
          technicalName: item.system.technicalName || item.system.name,
          score: item.score,
          reasons: item.reasons.slice(),
          coverage: Object.assign({}, item.coverage)
        };
      }),
      selection: selected ? {
        systemId: selected.id,
        technicalName: selected.system.technicalName || selected.system.name,
        score: selected.score,
        reasons: selected.reasons.slice(),
        coverage: Object.assign({}, selected.coverage)
      } : null,
      calculation: selected && calculation ? {
        areaM2: calculation.areaM2,
        wastePercent: 0,
        rows: calculation.rows.map(function (row) {
          return {
            phase: row.phase,
            technicalName: row.technicalName || row.name,
            consumptionKgM2: row.consumption,
            officialLabel: row.officialLabel,
            coats: row.coats,
            requiredKg: row.requiredKg,
            documentStatus: row.documentStatus,
            projectConsumption: row.projectConsumption
          };
        }),
        totalRequiredKg: calculation.totalRequiredKg,
        coverage: Object.assign({}, calculation.coverage)
      } : null,
      pendingData: (pending || []).slice(),
      decision: nonDefinitiveDecision(effectiveAssessment)
    };
  }

  return Object.freeze({
    SCORE_WEIGHTS: SCORE_WEIGHTS,
    MIN_COMPATIBILITY_SCORE: MIN_COMPATIBILITY_SCORE,
    STORAGE_TTL_MS: STORAGE_TTL_MS,
    API_ENDPOINT_PATH: API_ENDPOINT_PATH,
    API_PROTOCOL_VERSION: API_PROTOCOL_VERSION,
    CONSENT_COPY_VERSION: CONSENT_COPY_VERSION,
    APPROVED_REMOTE_API_ENDPOINTS: APPROVED_REMOTE_API_ENDPOINTS,
    TECHNICAL_STORAGE_FIELDS: TECHNICAL_STORAGE_FIELDS,
    normalize: normalize,
    safeCatalogUrl: safeCatalogUrl,
    safeApiEndpoint: safeApiEndpoint,
    isValidInternationalPhone: isValidInternationalPhone,
    submissionIdentity: submissionIdentity,
    toNumber: toNumber,
    round: round,
    derivedNeeds: derivedNeeds,
    contextualTerms: contextualTerms,
    documentationCoverage: documentationCoverage,
    scoreSystem: scoreSystem,
    rankSystems: rankSystems,
    criticalDataGaps: criticalDataGaps,
    isSystemVerifiable: isSystemVerifiable,
    assessCompatibility: assessCompatibility,
    calculateSystem: calculateSystem,
    buildPendingData: buildPendingData,
    nonDefinitiveDecision: nonDefinitiveDecision,
    minimizeContact: minimizeContact,
    hasContactRoute: hasContactRoute,
    sanitizeStoredProject: sanitizeStoredProject,
    buildStoredProject: buildStoredProject,
    isStoredProjectFresh: isStoredProjectFresh,
    buildDossier: buildDossier
  });
});

(function () {
  "use strict";
  if (typeof document === "undefined") return;

  var STORAGE_KEY = "idpProjectHub:v1";
  var API_PATH = "/api/project-hub/projects";

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function safeUrl(value) {
    var core = window.IDPProjectHubCore;
    return core && typeof core.safeCatalogUrl === "function"
      ? core.safeCatalogUrl(value, window.location.href)
      : "";
  }

  function formatNumber(value, decimals) {
    return new Intl.NumberFormat("es-ES", {
      minimumFractionDigits: decimals == null ? 0 : decimals,
      maximumFractionDigits: decimals == null ? 2 : decimals
    }).format(Number(value) || 0);
  }

  function makeProjectId() {
    var stamp = new Date().toISOString().replace(/[-:TZ.]/g, "").slice(0, 14);
    var suffix;
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
      suffix = window.crypto.randomUUID().split("-")[0].toUpperCase();
    } else {
      suffix = Math.random().toString(36).slice(2, 10).toUpperCase();
    }
    return "IDP-PV-" + stamp + "-" + suffix;
  }

  function init(root) {
    if (!root || root.dataset.projectHubReady === "true") return;
    root.dataset.projectHubReady = "true";

    var Core = window.IDPProjectHubCore;
    var recipesRoot = window.IDPSystemRecipes;
    var marketMap = window.IDPSystemMarketMap;
    var calculatorCore = window.IDPCalculatorCore;
    var form = root.querySelector("[data-project-form]");
    var steps = Array.from(root.querySelectorAll("[data-project-step]"));
    var indicators = Array.from(root.querySelectorAll("[data-project-step-indicator]"));
    var previousButton = root.querySelector("[data-project-previous]");
    var nextButton = root.querySelector("[data-project-next]");
    var generateButton = root.querySelector("[data-project-generate]");
    var formStatus = root.querySelector("[data-project-form-status]");
    var dossier = root.querySelector("[data-project-dossier]");
    var comparison = root.querySelector("[data-project-comparison]");
    var serviceConsent = root.querySelector("[data-project-consent-service]");
    var commercialConsent = root.querySelector("[data-project-consent-commercial]");
    var contactFields = Array.from(root.querySelectorAll("[data-project-contact]"));
    var consentCopyVersion = root.dataset.consentCopyVersion || "unversioned";
    var apiConfigured = root.dataset.apiEnabled === "true";
    var consentVersionValid = consentCopyVersion === Core.CONSENT_COPY_VERSION;
    var apiEnabled = apiConfigured && consentVersionValid;
    var state = {
      step: 0,
      projectId: makeProjectId(),
      createdAt: new Date().toISOString(),
      allRanking: [],
      ranking: [],
      assessment: null,
      selectedId: "",
      calculation: null,
      pending: [],
      dossier: null,
      apiAttempt: null
    };

    if (!Core || !recipesRoot || !marketMap || !calculatorCore || !form) {
      if (formStatus) {
        formStatus.hidden = false;
        formStatus.textContent = "No se han podido cargar los datos técnicos necesarios. Recarga la página antes de continuar.";
      }
      return;
    }

    var sectorLabels = (marketMap.sectors || []).reduce(function (map, item) {
      map[item.id] = item.label;
      return map;
    }, {});
    var needLabels = (marketMap.needs || []).reduce(function (map, item) {
      map[item.id] = item.label;
      return map;
    }, {});

    function populateSelect(select, items) {
      if (!select) return;
      items.forEach(function (item) {
        var option = document.createElement("option");
        option.value = item.id;
        option.textContent = item.label;
        select.appendChild(option);
      });
    }

    populateSelect(root.querySelector("[data-project-sector]"), marketMap.sectors || []);
    populateSelect(root.querySelector("[data-project-need]"), marketMap.needs || []);
    root.querySelector("[data-project-step-total]").textContent = String(steps.length);

    function showStatus(message) {
      formStatus.textContent = message || "";
      formStatus.hidden = !message;
    }

    function showStep(index) {
      state.step = Math.max(0, Math.min(steps.length - 1, index));
      steps.forEach(function (step, position) { step.hidden = position !== state.step; });
      indicators.forEach(function (indicator, position) {
        indicator.classList.toggle("is-complete", position < state.step);
        if (position === state.step) indicator.setAttribute("aria-current", "step");
        else indicator.removeAttribute("aria-current");
      });
      root.querySelector("[data-project-step-current]").textContent = String(state.step + 1);
      previousButton.hidden = state.step === 0;
      nextButton.hidden = state.step === steps.length - 1;
      generateButton.hidden = state.step !== steps.length - 1;
      showStatus("");
    }

    function validateStep(index) {
      var invalid = Array.from(steps[index].querySelectorAll("input, select, textarea")).find(function (field) {
        return !field.checkValidity();
      });
      if (!invalid) return true;
      showStatus("Completa los campos obligatorios de este paso antes de continuar.");
      invalid.reportValidity();
      invalid.focus();
      return false;
    }

    function formValue(name) {
      var field = form.elements.namedItem(name);
      return field ? String(field.value || "").trim() : "";
    }

    function getInput() {
      var area = Core.toNumber(formValue("area"), 0);
      var sector = formValue("sector");
      var need = formValue("need");
      return {
        sector: sector,
        sectorLabel: sectorLabels[sector] || sector,
        need: need,
        needLabel: needLabels[need] || need,
        support: formValue("support"),
        condition: formValue("condition"),
        exposure: formValue("exposure"),
        traffic: formValue("traffic"),
        finish: formValue("finish"),
        areaM2: area,
        urgency: formValue("urgency"),
        description: formValue("description")
      };
    }

    function getContact() {
      function contactValue(name) {
        var field = root.querySelector('[data-project-contact][name="' + name + '"]');
        return field ? String(field.value || "").trim() : "";
      }
      return Core.minimizeContact({
        companyProject: contactValue("companyProject"),
        name: contactValue("contactName"),
        email: contactValue("contactEmail"),
        phone: contactValue("contactPhone"),
        locality: contactValue("contactLocality"),
        preferredChannel: contactValue("preferredChannel")
      });
    }

    function setContact(contact) {
      var value = Core.minimizeContact(contact);
      var mapping = {
        companyProject: value.companyProject,
        contactName: value.name,
        contactEmail: value.email,
        contactPhone: value.phone,
        contactLocality: value.locality,
        preferredChannel: value.preferredChannel
      };
      contactFields.forEach(function (field) {
        if (Object.prototype.hasOwnProperty.call(mapping, field.name)) field.value = mapping[field.name];
      });
    }

    function clearSensitiveFields() {
      contactFields.forEach(function (field) { field.value = ""; });
      if (serviceConsent) serviceConsent.checked = false;
      if (commercialConsent) commercialConsent.checked = false;
    }

    function inputLabel(name, value) {
      var field = form.elements.namedItem(name);
      if (!field || !value) return "Pendiente";
      if (field.tagName === "SELECT") {
        var option = Array.from(field.options).find(function (item) { return item.value === value; });
        return option ? option.textContent : value;
      }
      return value;
    }

    function renderCriteria(input) {
      var items = [
        ["Sector", input.sectorLabel],
        ["Necesidad", input.needLabel],
        ["Soporte", inputLabel("support", input.support)],
        ["Estado", inputLabel("condition", input.condition)],
        ["Exposición", inputLabel("exposure", input.exposure)],
        ["Tráfico", inputLabel("traffic", input.traffic)],
        ["Acabado", inputLabel("finish", input.finish)],
        ["Superficie", formatNumber(input.areaM2, 2) + " m²"]
      ];
      root.querySelector("[data-project-criteria]").innerHTML = items.map(function (item) {
        return '<div class="idp-project-hub__criterion"><span>' + escapeHtml(item[0]) + '</span><strong>' + escapeHtml(item[1]) + "</strong></div>";
      }).join("");
    }

    function renderComparison() {
      if (!state.assessment || !state.assessment.compatible) {
        var gapItems = state.assessment && state.assessment.criticalGaps.length
          ? "<ul>" + state.assessment.criticalGaps.map(function (gap) { return "<li>" + escapeHtml(gap) + "</li>"; }).join("") + "</ul>"
          : "<p>No existe una coincidencia directa suficiente de sector, necesidad y cobertura documental.</p>";
        comparison.innerHTML =
          '<div class="idp-project-hub__compatibility-block" role="status">' +
            "<strong>Sin sistema compatible verificable</strong>" +
            "<p>No se muestra una preselección ni se calculan cantidades hasta completar la información necesaria.</p>" +
            gapItems +
          "</div>";
        return;
      }

      var top = state.ranking.slice(0, 3);
      comparison.innerHTML = top.map(function (item, index) {
        var system = item.system;
        var title = system.technicalName || system.name;
        var systemUrl = safeUrl(system.systemUrl);
        var links = [];
        if (systemUrl) links.push('<a href="' + escapeHtml(systemUrl) + '">Ver sistema</a>');
        return '<article class="idp-project-hub__comparison-card' + (item.id === state.selectedId ? " is-selected" : "") + '" data-comparison-system="' + escapeHtml(item.id) + '">' +
          '<div class="idp-project-hub__comparison-rank"><span>Preselección ' + (index + 1) + '</span><span class="idp-project-hub__comparison-score">' + item.score + " puntos</span></div>" +
          "<h4>" + escapeHtml(title) + "</h4>" +
          '<p class="idp-project-hub__comparison-code">' + escapeHtml(item.id) + "</p>" +
          "<ul>" + item.reasons.slice(0, 5).map(function (reason) { return "<li>" + escapeHtml(reason) + "</li>"; }).join("") + "</ul>" +
          "<dl>" +
            "<div><dt>Capas</dt><dd>" + item.coverage.totalLayers + "</dd></div>" +
            "<div><dt>Calculables</dt><dd>" + item.coverage.calculableLayers + "</dd></div>" +
            "<div><dt>Capas con ficha validada</dt><dd>" + item.coverage.verifiedLayers + "</dd></div>" +
          "</dl>" +
          '<div class="idp-project-hub__comparison-actions">' +
            '<button class="idp-project-hub__button' + (item.id === state.selectedId ? " idp-project-hub__button--secondary" : "") + '" type="button" data-project-select-system="' + escapeHtml(item.id) + '">' + (item.id === state.selectedId ? "Sistema seleccionado" : "Usar en el expediente") + "</button>" +
            links.join("") +
          "</div>" +
        "</article>";
      }).join("");
    }
    function documentStatus(row) {
      if (Core.normalize(row.documentStatus) === "validada") {
        return { label: "Capa con ficha validada", className: " idp-project-hub__document-status--verified" };
      }
      if (row.projectConsumption) return { label: "Consumo de proyecto", className: "" };
      if (row.officialLabel) return { label: "Dato registrado; revisar ficha", className: "" };
      return { label: "Revisión pendiente", className: "" };
    }

    function selectedRankingItem() {
      return state.ranking.find(function (item) { return item.id === state.selectedId; }) || state.ranking[0] || null;
    }

    function renderCalculation(input) {
      var selected = selectedRankingItem();
      var rowsTarget = root.querySelector("[data-project-calculation-rows]");
      if (!state.assessment || !state.assessment.compatible || !selected) {
        state.calculation = null;
        rowsTarget.innerHTML =
          '<tr class="idp-project-hub__calculation-blocked"><td colspan="5"><strong>Sin sistema compatible verificable.</strong> El cálculo está bloqueado hasta completar los datos críticos o disponer de cobertura documental suficiente.</td></tr>';
        root.querySelector("[data-project-calculation-total]").textContent = "—";
        root.querySelector("[data-project-calculation-note]").textContent = "Cálculo no disponible.";
        return;
      }

      state.calculation = Core.calculateSystem(selected.system, input.areaM2, calculatorCore);
      rowsTarget.innerHTML = state.calculation.rows.map(function (row) {
        var status = documentStatus(row);
        var consumption = row.officialLabel || (formatNumber(row.consumption, 3) + " kg/m²");
        return "<tr>" +
          '<th scope="row">' + escapeHtml(row.technicalName || row.name) + "<span>" + escapeHtml(row.phase) + "</span></th>" +
          "<td>" + escapeHtml(consumption) + "</td>" +
          "<td>" + escapeHtml(row.coats) + "</td>" +
          "<td>" + formatNumber(row.requiredKg, 2) + " kg</td>" +
          '<td><span class="idp-project-hub__document-status' + status.className + '">' + escapeHtml(status.label) + "</span></td>" +
        "</tr>";
      }).join("");
      root.querySelector("[data-project-calculation-total]").textContent = formatNumber(state.calculation.totalRequiredKg, 2) + " kg";
      root.querySelector("[data-project-calculation-note]").textContent =
        (selected.system.technicalName || selected.system.name) + " · " + formatNumber(input.areaM2, 2) + " m² · sin merma.";
    }
    function renderPending(input) {
      var selected = selectedRankingItem();
      var items = Core.buildPendingData(input, selected && selected.system);
      if (state.assessment && !state.assessment.compatible) {
        items.unshift("Sin sistema compatible verificable: la revisión técnica debe resolver la compatibilidad antes de calcular.");
        (state.assessment.criticalGaps || []).forEach(function (gap) {
          items.push("Dato crítico: " + gap);
        });
      }
      state.pending = Array.from(new Set(items));
      root.querySelector("[data-project-pending]").innerHTML = state.pending.map(function (item) {
        return "<li>" + escapeHtml(item) + "</li>";
      }).join("");
    }
    function rebuildDossier(input) {
      state.dossier = Core.buildDossier(
        input,
        state.ranking,
        state.selectedId,
        state.calculation,
        state.pending,
        { projectId: state.projectId, createdAt: state.createdAt, contact: getContact(), assessment: state.assessment }
      );
    }

    function renderDossier(input, shouldScroll) {
      renderCriteria(input);
      renderComparison();
      renderCalculation(input);
      renderPending(input);
      rebuildDossier(input);
      root.querySelector("[data-project-id]").textContent = state.projectId;
      root.querySelector("[data-project-dossier-summary]").textContent =
        state.assessment && state.assessment.compatible
          ? "Se han evaluado " + state.assessment.evaluatedCount + " sistemas y se muestran hasta tres coincidencias que superan el umbral documental mínimo."
          : "Sin sistema compatible verificable. El expediente conserva los datos pendientes, pero no propone sistema ni calcula cantidades.";
      dossier.hidden = false;
      if (shouldScroll !== false) dossier.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    function generate(shouldScroll) {
      if (!form.checkValidity()) {
        showStatus("Completa todos los datos obligatorios antes de generar la preselección.");
        var invalid = form.querySelector(":invalid");
        if (invalid) {
          var invalidStep = steps.findIndex(function (step) { return step.contains(invalid); });
          if (invalidStep >= 0) showStep(invalidStep);
          invalid.reportValidity();
          invalid.focus();
        }
        return false;
      }
      var input = getInput();
      state.allRanking = Core.rankSystems(recipesRoot, marketMap, input);
      state.assessment = Core.assessCompatibility(state.allRanking, input);
      state.ranking = state.assessment.compatibleSystems.slice();
      if (state.assessment.compatible) {
        if (!state.selectedId || !state.ranking.some(function (item) { return item.id === state.selectedId; })) {
          state.selectedId = state.ranking[0].id;
        }
      } else {
        state.selectedId = "";
        state.calculation = null;
      }
      showStatus("");
      renderDossier(input, shouldScroll);
      return true;
    }
    function serializeForm() {
      var values = {};
      new FormData(form).forEach(function (value, key) { values[key] = String(value); });
      return values;
    }

    function setStorageStatus(message) {
      root.querySelector("[data-project-storage-status]").textContent = message || "";
    }

    function readLocalRecord() {
      try {
        var raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return { payload: null, status: "empty" };
        var parsed = JSON.parse(raw);
        if (!Core.isStoredProjectFresh(parsed, Date.now())) {
          localStorage.removeItem(STORAGE_KEY);
          return { payload: null, status: "expired" };
        }
        var sanitized = Core.sanitizeStoredProject(parsed);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(sanitized));
        return { payload: sanitized, status: "available" };
      } catch (error) {
        try { localStorage.removeItem(STORAGE_KEY); } catch (cleanupError) { /* Sin acción adicional. */ }
        return { payload: null, status: "invalid" };
      }
    }

    function saveLocal() {
      try {
        var payload = Core.buildStoredProject({
          projectId: state.projectId,
          createdAt: state.createdAt,
          selectedId: state.selectedId,
          form: serializeForm()
        }, Date.now());
        localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
        var expiresAt = new Date(Date.parse(payload.savedAt) + Core.STORAGE_TTL_MS);
        setStorageStatus("Datos técnicos guardados hasta el " + expiresAt.toLocaleDateString("es-ES") + ". No se han guardado datos de contacto ni consentimientos.");
      } catch (error) {
        setStorageStatus("El navegador no permite guardar este expediente localmente.");
      }
    }

    function restoreLocal() {
      clearSensitiveFields();
      var record = readLocalRecord();
      if (!record.payload) {
        if (record.status === "expired") setStorageStatus("El expediente local había superado 30 días y se ha eliminado automáticamente.");
        else if (record.status === "invalid") setStorageStatus("El expediente local no era válido y se ha eliminado.");
        else setStorageStatus("No hay un expediente local guardado.");
        return;
      }
      var payload = record.payload;
      Object.keys(payload.form || {}).forEach(function (name) {
        var field = form.elements.namedItem(name);
        if (field) field.value = payload.form[name];
      });
      state.projectId = payload.projectId || makeProjectId();
      state.createdAt = payload.createdAt || new Date().toISOString();
      state.selectedId = payload.selectedId || "";
      showStep(0);
      setStorageStatus("Datos técnicos recuperados. Contacto y consentimientos permanecen vacíos.");
      if (form.checkValidity()) generate(false);
    }

    function clearLocal() {
      clearSensitiveFields();
      try {
        localStorage.removeItem(STORAGE_KEY);
        setStorageStatus("Expediente local borrado. Contacto y consentimientos permanecen vacíos.");
      } catch (error) {
        setStorageStatus("No se ha podido borrar el expediente local.");
      }
    }
    function exportPayload(updatedAt) {
      if (!state.dossier && !generate(false)) return null;
      rebuildDossier(getInput());
      var payload = JSON.parse(JSON.stringify(state.dossier));
      payload.updatedAt = updatedAt || new Date().toISOString();
      payload.consents = {
        copyVersion: consentCopyVersion,
        service: Boolean(serviceConsent && serviceConsent.checked),
        commercial: Boolean(commercialConsent && commercialConsent.checked)
      };
      return payload;
    }

    function prepareApiAttempt() {
      if (!generate(false)) return null;
      var candidate = exportPayload();
      if (!candidate) return null;
      var identity = Core.submissionIdentity(candidate);
      if (!identity) return null;
      if (state.apiAttempt && state.apiAttempt.identity === identity) return state.apiAttempt;

      if (state.apiAttempt) {
        state.projectId = makeProjectId();
        state.createdAt = new Date().toISOString();
        state.apiAttempt = null;
        if (!generate(false)) return null;
        candidate = exportPayload();
        identity = Core.submissionIdentity(candidate);
        if (!identity) return null;
      }

      candidate.updatedAt = new Date().toISOString();
      state.apiAttempt = {
        identity: Core.submissionIdentity(candidate),
        projectId: candidate.projectId,
        body: JSON.stringify(candidate)
      };
      return state.apiAttempt;
    }

    function exportJson() {
      var payload = exportPayload();
      if (!payload) return;
      var blob = new Blob([JSON.stringify(payload, null, 2)], { type: "application/json;charset=utf-8" });
      var url = URL.createObjectURL(blob);
      var anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = "expediente-" + String(state.projectId).toLowerCase() + ".json";
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
      URL.revokeObjectURL(url);
    }

    function setApiStatus(message, isError) {
      var target = root.querySelector("[data-project-api-status]");
      target.textContent = message || "";
      target.classList.toggle("is-error", Boolean(isError));
    }

    function apiFailureMessage(payload, status) {
      var code = payload && payload.error && payload.error.code ? payload.error.code : "";
      if (code === "consent_copy_version_mismatch") {
        return "La información de privacidad ha cambiado. Recarga la página y vuelve a confirmar la solicitud.";
      }
      if (code === "origin_not_allowed") {
        return "El origen de la tienda no está autorizado por el servicio técnico.";
      }
      if (code === "international_phone_prefix_required" || code === "invalid_phone") {
        return "Revisa el teléfono e incluye el prefijo internacional, por ejemplo +34 o 0034.";
      }
      if (code === "service_consent_required") {
        return "Debes volver a confirmar la solicitud técnica antes de enviarla.";
      }
      if (code === "idempotency_conflict" || code === "project_id_conflict") {
        return "El expediente cambió durante un reintento. Revisa los datos y genera una nueva solicitud.";
      }
      if (code === "invalid_api_response") return "El servicio respondió sin una confirmación válida del expediente.";
      if (status === 413) return "El expediente contiene demasiada información para enviarlo online.";
      if (status === 429) return "Se ha alcanzado el límite temporal de solicitudes. Inténtalo de nuevo más tarde.";
      return "No se ha podido enviar el expediente. Puedes exportarlo y utilizar la página interna de Contacto.";
    }

    async function submitApi(button) {
      if (apiConfigured && !consentVersionValid) {
        setApiStatus("La versión de privacidad del formulario no coincide con la versión técnica activa. Recarga la página.", true);
        return;
      }
      if (!apiEnabled) {
        setApiStatus("El envío online no está habilitado. Utiliza la página interna de Contacto.", true);
        return;
      }
      if (!serviceConsent || !serviceConsent.checked) {
        setApiStatus("Debes confirmar la solicitud técnica antes de enviar el expediente.", true);
        serviceConsent.focus();
        return;
      }
      var contact = getContact();
      if (!Core.hasContactRoute(contact)) {
        setApiStatus("Indica un correo electrónico o un teléfono para poder responder a la solicitud.", true);
        var firstContact = root.querySelector('[data-project-contact][name="contactEmail"]');
        if (firstContact) firstContact.focus();
        return;
      }
      var emailField = root.querySelector('[data-project-contact][name="contactEmail"]');
      if (emailField && contact.email && !emailField.checkValidity()) {
        setApiStatus("Revisa el formato del correo electrónico antes de enviar.", true);
        emailField.reportValidity();
        emailField.focus();
        return;
      }
      var phoneField = root.querySelector('[data-project-contact][name="contactPhone"]');
      if (phoneField && contact.phone && !Core.isValidInternationalPhone(contact.phone)) {
        setApiStatus("Revisa el teléfono e incluye el prefijo internacional, por ejemplo +34 o 0034.", true);
        phoneField.focus();
        return;
      }

      var configuredEndpoint = root.dataset.apiEndpoint || "";
      var endpointHref = Core.safeApiEndpoint(
        configuredEndpoint,
        window.location.href,
        apiEnabled,
        Core.APPROVED_REMOTE_API_ENDPOINTS
      );
      if (!endpointHref) {
        setApiStatus("El endpoint de envío no está incluido en la configuración segura de Proyecto Vivo.", true);
        return;
      }
      var attempt = prepareApiAttempt();
      if (!attempt) return;

      var controller = typeof AbortController === "function" ? new AbortController() : null;
      var timeoutId = controller ? window.setTimeout(function () { controller.abort(); }, 15000) : null;
      var sent = false;
      button.disabled = true;
      setApiStatus("Enviando expediente para revisión…", false);
      try {
        var requestOptions = {
          method: "POST",
          mode: "cors",
          credentials: "omit",
          cache: "no-store",
          referrerPolicy: "strict-origin-when-cross-origin",
          headers: {
            "Content-Type": "application/json",
            "Idempotency-Key": attempt.projectId,
            "X-IDP-Project-Version": Core.API_PROTOCOL_VERSION
          },
          body: attempt.body
        };
        if (controller) requestOptions.signal = controller.signal;
        var response = await fetch(endpointHref, requestOptions);
        var responsePayload = null;
        try {
          responsePayload = await response.json();
        } catch (parseError) {
          responsePayload = null;
        }
        if (!response.ok) {
          var apiError = new Error("HTTP " + response.status);
          apiError.status = response.status;
          apiError.payload = responsePayload;
          throw apiError;
        }
        var returnedProjectId = responsePayload && responsePayload.project && responsePayload.project.id
          ? String(responsePayload.project.id)
          : "";
        if (!returnedProjectId || returnedProjectId !== attempt.projectId) {
          var contractError = new Error("Respuesta API no válida");
          contractError.status = 502;
          contractError.payload = { error: { code: "invalid_api_response" } };
          throw contractError;
        }
        state.apiAttempt = null;
        clearSensitiveFields();
        rebuildDossier(getInput());
        sent = true;
        window.idpAnalytics?.track("generate_lead", "project_hub");
        button.textContent = "Solicitud enviada";
        button.setAttribute("aria-disabled", "true");
        setApiStatus("Expediente " + returnedProjectId + " enviado. La preselección queda pendiente de revisión técnica.", false);
      } catch (error) {
        if (error && error.name === "AbortError") {
          setApiStatus("El servicio ha tardado demasiado en responder. Puedes reintentar; se conservará el mismo envío solo en esta pestaña.", true);
        } else {
          setApiStatus(apiFailureMessage(error && error.payload, error && error.status), true);
        }
      } finally {
        if (timeoutId) window.clearTimeout(timeoutId);
        if (!sent) button.disabled = false;
      }
    }
    previousButton.addEventListener("click", function () { showStep(state.step - 1); });
    nextButton.addEventListener("click", function () {
      if (validateStep(state.step)) showStep(state.step + 1);
    });
    form.addEventListener("submit", function (event) {
      event.preventDefault();
      generate(true);
    });
    comparison.addEventListener("click", function (event) {
      var button = event.target.closest("[data-project-select-system]");
      if (!button) return;
      state.selectedId = button.dataset.projectSelectSystem;
      renderDossier(getInput(), false);
    });
    root.querySelector("[data-project-save]").addEventListener("click", saveLocal);
    root.querySelector("[data-project-restore]").addEventListener("click", restoreLocal);
    root.querySelector("[data-project-clear]").addEventListener("click", clearLocal);
    root.querySelector("[data-project-export]").addEventListener("click", exportJson);
    root.querySelector("[data-project-print]").addEventListener("click", function () {
      if (!state.dossier && !generate(false)) return;
      window.print();
    });
    var apiButton = root.querySelector("[data-project-submit-api]");
    if (apiButton) apiButton.addEventListener("click", function () { submitApi(apiButton); });

    clearSensitiveFields();
    showStep(0);
    if (apiConfigured && !consentVersionValid) {
      setApiStatus("El envío permanece bloqueado porque la versión de privacidad no coincide con el contrato activo.", true);
    }
    var initialRecord = readLocalRecord();
    if (initialRecord.status === "available") {
      setStorageStatus("Hay datos técnicos guardados para recuperar. Caducarán automáticamente a los 30 días.");
    } else if (initialRecord.status === "expired") {
      setStorageStatus("El expediente local había superado 30 días y se ha eliminado automáticamente.");
    } else if (initialRecord.status === "invalid") {
      setStorageStatus("El expediente local no era válido y se ha eliminado.");
    }
  }

  function boot() {
    document.querySelectorAll("[data-idp-project-hub]").forEach(init);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot, { once: true });
  else boot();
})();
